export default __webpack_public_path__ + "ef6b60b96390a63a14dc62adaaf029d9.svg";